import { PoaUser } from "iron-session";
import useSWR, { SWRResponse } from "swr";
import { IUseSelectedPowerOfAttorney } from "./types";
import { useMemo } from "react";
import usePowerOfAttorney from "../usePowerOfAttorney";
import commonSwrConfig from "../commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";

const useSelectedPowerOfAttorney: IUseSelectedPowerOfAttorney = () => {
  const { update } = useSession();

  const { data: powerOfAttorneys } = usePowerOfAttorney();

  const { data, error, isLoading }: SWRResponse<PoaUser, unknown> = useSWR(
    "/api/poaUser",
    commonFetcher<PoaUser>,
    commonSwrConfig(update),
  );

  const deletePoa = async () => {
    const response = await fetch("/api/poaUser", {
      method: "DELETE",
      headers: [["accepts", "application/json"]],
    });

    if (response.status !== 200) {
      throw response.status;
    }
  };

  const selectedUser = useMemo(() => {
    if (
      powerOfAttorneys &&
      powerOfAttorneys.length > 0 &&
      data?.userId &&
      powerOfAttorneys.some(p => p.customerNumber === data?.userId)
    ) {
      return data;
    }
    return undefined;
  }, [data, powerOfAttorneys]);

  return {
    data: selectedUser,
    deletePoa,
    isLoading,
    error,
  };
};

export default useSelectedPowerOfAttorney;
